import * as React from "react";
import { Box, Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export default function StepListProjects({
  value = ["Uppgift 1"],
  onNext,
  onBack,
  showActions = true,
}) {
  const [rows, setRows] = React.useState(value);

  // Synka uppåt löpande så att global footer kan validera / använda datat
  React.useEffect(() => {
    onNext?.({ initialItems: rows.filter(Boolean) });
  }, [rows, onNext]);

  // Om parent skickar nytt value, uppdatera lokalt
  React.useEffect(() => {
    setRows(value);
  }, [value?.join("|")]);

  const set = (i, v) => setRows((r) => r.map((x, idx) => (idx === i ? v : x)));
  const addRow = () => setRows((r) => [...r, ""]);
  const remove = (i) => setRows((r) => r.filter((_, idx) => idx !== i));

  const submit = () => onNext?.({ initialItems: rows.filter(Boolean) });

  return (
    <Stack spacing={3} sx={{ p: 2 }}>
      <Typography variant="h4" fontWeight={800}>
        Lista dina uppgifter
      </Typography>

      <Stack spacing={1}>
        {rows.map((v, i) => (
          <Stack
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            direction="row"
            spacing={1}
            alignItems="center"
          >
            <TextField
              fullWidth
              value={v}
              onChange={(e) => set(i, e.target.value)}
              placeholder={`Uppgift ${i + 1}`}
              size="small"
            />
            {rows.length > 1 && (
              <IconButton aria-label="Ta bort rad" onClick={() => remove(i)}>
                <CloseRoundedIcon />
              </IconButton>
            )}
          </Stack>
        ))}
        <Box>
          <Button onClick={addRow}>+ Lägg till rad</Button>
        </Box>
      </Stack>

      {showActions && (
        <Stack direction="row" spacing={2}>
          <Button onClick={onBack}>Tillbaka</Button>
          <Button variant="contained" onClick={submit}>
            Kom igång
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
